import { FC } from 'react';
import { Wrapper } from './pages.styled';
import { Error } from '../components';
import { MobileAppModal } from '../components';

export const ErrorPage: FC = () => {
  return (
    <Wrapper>
      <Error />
      <MobileAppModal />
    </Wrapper>
  );
};
